import { __extends } from "tslib";
import BaseObserver from "../BaseObserver";
import EventTypes from "../EventTypes";
/**
 * Url
 * Knows how to detect when document url changes
 * @TODO: find better implementation by making using of
 * pushState (probably overwrite prototype) to make it more
 * reliable
 */
var UrlChange = /** @class */ (function (_super) {
    __extends(UrlChange, _super);
    function UrlChange() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.intervalTimeout = 1500;
        _this.getUrl = function () { return document.location.href; };
        _this.detectChange = function () {
            var current = _this.getUrl();
            if (_this.isStarted && current !== UrlChange.previousUrl) {
                var event_1 = {
                    current: current,
                    previous: UrlChange.previousUrl,
                    type: EventTypes.UrlChange,
                };
                UrlChange.previousUrl = current;
                _this.callback(event_1);
            }
        };
        _this.handleInterval = function (event) {
            _this.detectChange();
            _this.startOrContinueDetectInterval();
        };
        _this.startOrContinueDetectInterval = function () {
            _this.detectProcess = setTimeout(_this.handleInterval, _this.intervalTimeout);
        };
        _this.stopDetectInterval = function () { return _this.detectProcess && clearTimeout(_this.detectProcess); };
        return _this;
    }
    UrlChange.prototype.start = function () {
        _super.prototype.start.call(this);
        if (!UrlChange.previousUrl) {
            UrlChange.previousUrl = this.getUrl();
        }
        this.startOrContinueDetectInterval();
    };
    UrlChange.prototype.stop = function () {
        _super.prototype.stop.call(this);
        this.stopDetectInterval();
    };
    return UrlChange;
}(BaseObserver));
export default UrlChange;
//# sourceMappingURL=UrlChange.js.map